import { useAuth } from "@/auth/useAuth";
import { LoginOverlay } from "@/components/ui/login-overlay/login-overlay";
import { isDev } from "@/lib/utils";
import { SelectDevEnvironment } from "./select-dev-environment";
import { Outlet } from "react-router-dom";
import { useWorkOrderOperation } from "@/queries/work-order/use-work-order-operation";

export function AuthGuard() {
  const { isLoggedIn, login, loading } = useAuth();

  return (
    <>
      {!isLoggedIn && (
        <LoginOverlay onLoginClick={login} loading={loading}>
          {isDev() && <SelectDevEnvironment />}
        </LoginOverlay>
      )}
      {isLoggedIn && <Outlet />}
    </>
  );
}

export function OperationGuard() {
  const { noActiveOperation } = useWorkOrderOperation();

  if (noActiveOperation) return null;

  return <Outlet />;
}
